import cx from "classnames"
import * as React from "react"
import * as styles from "./styles.module.scss"
import LogoForbes from "../../../logos/Forbes"
import LogoFinancialTimes from "../../../logos/FinancialTimes"
import LogoWallStreetJournal from "../../../logos/WallStreetJournal"

export interface AboutLogosProps {
  inView: boolean
}

const AboutLogos: React.FC<AboutLogosProps> = ({ inView }) => {
  return (
    <ul
      className={cx({
        [styles.logos]: true,
        [styles.inView]: inView,
      })}
    >
      <li className={styles.logo}>
        <a
          className={styles.link}
          href="https://www.forbes.com/sites/truebridge/2017/04/24/how-better-mortgage-is-giving-control-back-to-homebuyers"
          target="_blank"
        >
          <LogoForbes />
        </a>
      </li>
      <li className={styles.logo}>
        <a
          className={styles.link}
          href="https://www.ft.com/content/e83f9a78-b1bc-11e6-9c37-5787335499a0"
          target="_blank"
        >
          <LogoFinancialTimes />
        </a>
      </li>
      <li className={styles.logo}>
        <a
          className={styles.link}
          href="https://www.wsj.com/articles/online-lenders-secret-to-success-past-failure-1465723802"
          target="_blank"
        >
          <LogoWallStreetJournal />
        </a>
      </li>
    </ul>
  )
}

export default AboutLogos
